import { datadogRum } from '@datadog/browser-rum';
import type { LDEvaluationDetail } from 'launchdarkly-react-client-sdk';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import type { PropsWithChildren } from 'react';
import { convertToLDIdentityContext } from '~/utils/convertToLDIdentityContext';
import { useAuth } from './AuthProvider';

const LAUNCH_DARKLY_CLIENT_ID = import.meta.env?.VITE_LAUNCH_DARKLY_CLIENT_ENV_ID ?? '';

export function FeatureFlagProvider({ children }: PropsWithChildren) {
  const { token } = useAuth();
  const userContext = convertToLDIdentityContext(token);

  return (
    <LDProvider
      clientSideID={LAUNCH_DARKLY_CLIENT_ID}
      context={userContext}
      options={{
        inspectors: [
          {
            type: 'flag-used',
            name: 'dd-inspector',
            method: (key: string, detail: LDEvaluationDetail) => {
              datadogRum.addFeatureFlagEvaluation(key, detail.value);
            },
          },
        ],
      }}
      reactOptions={{
        useCamelCaseFlagKeys: false,
      }}
    >
      {children}
    </LDProvider>
  );
}
